type Item = {
  text: string;
  id: string;
};

type Result = {
  items: Array<Item>;
  hasMore: boolean;
};

export const suggest = async (
  name: string,
  query: string,
  page: number
): Promise<Result> => {
  try {
    const params = new URLSearchParams({
      q: query,
      page: String(page),
    });

    const response = await fetch(
      `/suggest/${name}/suggest?${params.toString()}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error ${response.status}`);
    }

    const data: {
      items?: Array<{
        id: string | number;
        text: string;
      }>;
      hasMore?: boolean;
    } = await response.json();

    return {
      items:
        data.items?.map(
          (item): Item => ({
            id: String(item.id),
            text: item.text,
          })
        ) ?? [],
      hasMore: data.hasMore ?? false,
    };
  } catch (error) {
    console.error("Suggest request error", error);

    return {
      items: [],
      hasMore: false,
    };
  }
};
